export const PROD_ENVIRONMENT_ROUTE = "abstract.prophia.com";
export const DEV_ENVIRONMENT_ROUTE = "abstract.dev.prophia.com";
export const STAGING_ENVIRONMENT_ROUTE = "abstract.staging.prophia.com";
